import React from 'react';
import { Box, Flex } from '@edreamsodigeo/prisma-design-system';
import styled from '@emotion/styled';
import css from '@styled-system/css';

const TripDivider = (): JSX.Element => {
  return (
    <Box width="100%">
      <DotWrapper>
        <Dot />
      </DotWrapper>
      <DividerHorizontal />
    </Box>
  );
};

const DividerHorizontal = styled('hr')(() =>
  css({
    margin: 0,
    borderWidth: 0,
    borderColor: 'neutrals.5',
    borderStyle: 'solid',
    borderTopWidth: 1,
    transform: 'translateY(-50%)',
  })
);

const DotWrapper = styled(Flex)(
  css({
    position: 'relative',
  })
);

const Dot = styled(Flex)(
  css({
    size: '4px',
    borderRadius: '100%',
    backgroundColor: 'neutrals.5',
    position: 'absolute',
    left: '0',
    top: '50%',
    transform: 'translateY(-50%)',
    color: 'red',
  })
);

export default TripDivider;
